module.exports = __webpack_public_path__ + "img/1.272b468a.jpg";